import { state } from '../state.js';
import { reportingModalStyles } from '../styles/components/reportingModal.js';
import { eventBus } from '../utils/events.js';
import { bugData } from '../utils/bugData.js';
import { captureHostPage } from '../utils/capture.js';
import hotkeys from 'hotkeys-js';

// The "Powered by Waylight" wordmark — defined once, reused in the footer
// and the preflight-error attribution. Stays mid-gray (#7E7E7F) so it reads
// on both light and dark surfaces without theming.
const waylightWordmark = `
    <svg width="56" height="17" viewBox="0 0 105 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.014 17A9 9 0 1 1 17.986 17Z" fill="#EFAE2E"/><path d="M0.126 18H17.874A9 9 0 0 1 17.292 20H0.708A9 9 0 0 1 0.126 18ZM1.325 21.2H16.675A9 9 0 0 1 15.524 22.7H2.476A9 9 0 0 1 1.325 21.2ZM4.179 24.1H13.821A9 9 0 0 1 4.179 24.1Z" fill="#7E7E7F"/><path d="M47.52 23L50.8 13H53.98L50.56 23H47.52ZM40.94 23L44.06 13H46.72L43.66 23H40.94ZM40.6 23L37.2 13H40.38L43.48 23H40.6ZM47.5 23L44.48 13H47.14L50.24 23H47.5ZM60.1959 23L60.0959 20.84V18.02C60.0959 17.4867 60.0493 17.02 59.9559 16.62C59.8759 16.22 59.7093 15.9133 59.4559 15.7C59.2159 15.4733 58.8626 15.36 58.3959 15.36C58.0226 15.36 57.6959 15.4467 57.4159 15.62C57.1359 15.7933 56.8959 16.0267 56.6959 16.32L53.9559 15.42C54.1959 14.9267 54.5093 14.48 54.8959 14.08C55.2959 13.68 55.7826 13.36 56.3559 13.12C56.9293 12.88 57.5959 12.76 58.3559 12.76C59.3959 12.76 60.2759 12.9533 60.9959 13.34C61.7159 13.7267 62.2559 14.2667 62.6159 14.96C62.9759 15.6533 63.1559 16.4733 63.1559 17.42L63.1159 23H60.1959ZM57.4559 23.24C56.2826 23.24 55.3693 22.98 54.7159 22.46C54.0626 21.9267 53.7359 21.1667 53.7359 20.18C53.7359 19.1267 54.0759 18.34 54.7559 17.82C55.4359 17.3 56.3893 17.04 57.6159 17.04H60.3559V19.06H58.7759C58.1226 19.06 57.6493 19.1533 57.3559 19.34C57.0626 19.5133 56.9159 19.7667 56.9159 20.1C56.9159 20.34 57.0226 20.5333 57.2359 20.68C57.4626 20.8133 57.7693 20.88 58.1559 20.88C58.5426 20.88 58.8759 20.8 59.1559 20.64C59.4493 20.4667 59.6759 20.24 59.8359 19.96C60.0093 19.68 60.0959 19.38 60.0959 19.06H60.8959C60.8959 20.38 60.6093 21.4067 60.0359 22.14C59.4759 22.8733 58.6159 23.24 57.4559 23.24ZM66.6447 27.24C66.218 27.24 65.7647 27.16 65.2847 27C64.818 26.84 64.4247 26.6667 64.1047 26.48L65.2647 23.94C65.4514 24.0733 65.6314 24.1733 65.8047 24.24C65.9914 24.3067 66.158 24.34 66.3047 24.34C66.558 24.34 66.7847 24.2733 66.9847 24.14C67.1847 24.02 67.3447 23.82 67.4647 23.54L68.6447 20.76L71.5847 13H75.0447L70.6247 23.6C70.3314 24.32 70.0247 24.9533 69.7047 25.5C69.3847 26.0467 68.9847 26.4733 68.5047 26.78C68.038 27.0867 67.418 27.24 66.6447 27.24ZM67.8247 23L63.1447 13H66.6047L69.7447 20.76L70.8047 23H67.8247ZM75.4973 23V9H78.6173V23H75.4973ZM80.2336 23V13H83.3536V23H80.2336ZM81.7936 11.72C81.3269 11.72 80.9136 11.5467 80.5536 11.2C80.2069 10.84 80.0336 10.4267 80.0336 9.96C80.0336 9.46667 80.2069 9.05333 80.5536 8.72C80.9136 8.37333 81.3269 8.2 81.7936 8.2C82.2736 8.2 82.6869 8.37333 83.0336 8.72C83.3803 9.05333 83.5536 9.46667 83.5536 9.96C83.5536 10.4267 83.3803 10.84 83.0336 11.2C82.6869 11.5467 82.2736 11.72 81.7936 11.72ZM89.7009 27.28C88.8876 27.28 88.1743 27.2267 87.5609 27.12C86.9609 27.0133 86.4476 26.8733 86.0209 26.7C85.5943 26.5267 85.2409 26.3333 84.9609 26.12L86.1809 23.64C86.3943 23.7333 86.6476 23.8467 86.9409 23.98C87.2343 24.1267 87.5943 24.2533 88.0209 24.36C88.4476 24.4667 88.9609 24.52 89.5609 24.52C90.0276 24.52 90.4409 24.4267 90.8009 24.24C91.1743 24.0667 91.4609 23.7867 91.6609 23.4C91.8743 23.0267 91.9809 22.5533 91.9809 21.98V13H95.1009V21.86C95.1009 22.98 94.8876 23.9467 94.4609 24.76C94.0343 25.5733 93.4209 26.1933 92.6209 26.62C91.8209 27.06 90.8476 27.28 89.7009 27.28ZM88.9809 22.62C88.0476 22.62 87.2409 22.4333 86.5609 22.06C85.8943 21.6733 85.3743 21.1267 85.0009 20.42C84.6409 19.7133 84.4609 18.8733 84.4609 17.9C84.4609 16.8333 84.6409 15.92 85.0009 15.16C85.3743 14.4 85.8943 13.8133 86.5609 13.4C87.2409 12.9733 88.0476 12.76 88.9809 12.76C89.7543 12.76 90.4209 12.9733 90.9809 13.4C91.5543 13.8133 91.9943 14.4067 92.3009 15.18C92.6076 15.9533 92.7609 16.88 92.7609 17.96C92.7609 18.92 92.6076 19.7467 92.3009 20.44C91.9943 21.1333 91.5543 21.6733 90.9809 22.06C90.4209 22.4333 89.7543 22.62 88.9809 22.62ZM89.9009 20.02C90.3009 20.02 90.6409 19.9267 90.9209 19.74C91.2143 19.54 91.4343 19.2733 91.5809 18.94C91.7409 18.6067 91.8209 18.2267 91.8209 17.8C91.8209 17.3467 91.7409 16.9533 91.5809 16.62C91.4209 16.2867 91.1943 16.0267 90.9009 15.84C90.6209 15.6533 90.2809 15.56 89.8809 15.56C89.4943 15.56 89.1476 15.6533 88.8409 15.84C88.5476 16.0267 88.3143 16.2867 88.1409 16.62C87.9809 16.9533 87.8943 17.3467 87.8809 17.8C87.8943 18.2267 87.9809 18.6067 88.1409 18.94C88.3143 19.2733 88.5543 19.54 88.8609 19.74C89.1676 19.9267 89.5143 20.02 89.9009 20.02ZM96.5889 23V9H99.7089V23H96.5889ZM103.029 23V17.88H106.149V23H103.029ZM103.029 17.88C103.029 17.3467 102.969 16.9267 102.849 16.62C102.729 16.3 102.556 16.0667 102.329 15.92C102.102 15.7733 101.836 15.6933 101.529 15.68C100.929 15.6667 100.476 15.8333 100.169 16.18C99.8622 16.5133 99.7089 17.0267 99.7089 17.72H98.7689C98.7689 16.6667 98.9289 15.7733 99.2489 15.04C99.5689 14.2933 100.002 13.7267 100.549 13.34C101.109 12.9533 101.749 12.76 102.469 12.76C103.282 12.76 103.962 12.9267 104.509 13.26C105.056 13.58 105.462 14.0733 105.729 14.74C106.009 15.4067 106.149 16.26 106.149 17.3V17.88H103.029ZM111.753 23.24C110.566 23.24 109.679 22.96 109.093 22.4C108.519 21.8267 108.233 21.0133 108.233 19.96V9.88H111.353V19.18C111.353 19.58 111.426 19.8733 111.573 20.06C111.719 20.2467 111.946 20.34 112.253 20.34C112.373 20.34 112.513 20.3133 112.673 20.26C112.833 20.1933 112.979 20.1133 113.113 20.02L114.193 22.3C113.873 22.5667 113.486 22.7933 113.033 22.98C112.593 23.1533 112.166 23.24 111.753 23.24ZM106.673 15.62V13H113.633V15.62H106.673Z" transform="translate(-12 0)" fill="#7E7E7F"/></svg>
`;

// Convert an owner-supplied hex accent (#RGB / #RRGGBB) to an rgba string for
// focus rings. Falls back to the brand ring if the value isn't a clean hex.
const hexToRgba = ( hex, alpha ) => {
    if( typeof hex !== 'string' ) {
        return `rgba(21, 94, 239, ${alpha})`;
    }

    let value = hex.trim().replace('#', '');
    if( value.length === 3 ) {
        value = value.split('').map( ( c ) => c + c ).join('');
    }

    if( !/^[0-9a-fA-F]{6}$/.test( value ) ) {
        return `rgba(21, 94, 239, ${alpha})`;
    }

    const r = parseInt( value.substring(0, 2), 16 );
    const g = parseInt( value.substring(2, 4), 16 );
    const b = parseInt( value.substring(4, 6), 16 );

    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

// Pick a legible text color for a button painted in an arbitrary brand accent.
// Light accents (e.g. a yellow brand) get dark text; everything else gets white.
const pickContrast = ( hex ) => {
    if( typeof hex !== 'string' ) {
        return '#FFFFFF';
    }

    let value = hex.trim().replace('#', '');
    if( value.length === 3 ) {
        value = value.split('').map( ( c ) => c + c ).join('');
    }

    if( !/^[0-9a-fA-F]{6}$/.test( value ) ) {
        return '#FFFFFF';
    }

    const r = parseInt( value.substring(0, 2), 16 ) / 255;
    const g = parseInt( value.substring(2, 4), 16 ) / 255;
    const b = parseInt( value.substring(4, 6), 16 ) / 255;
    // Relative luminance (sRGB).
    const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;

    return luminance > 0.6 ? '#101828' : '#FFFFFF';
};

// Two-letter initials for the returning-visitor avatar.
const initialsFor = ( name ) => {
    const parts = ( name || '' ).trim().split(/\s+/).filter( Boolean );
    if( !parts.length ) {
        return '?';
    }
    if( parts.length === 1 ) {
        return parts[0].substring(0, 2).toUpperCase();
    }
    return ( parts[0][0] + parts[parts.length - 1][0] ).toUpperCase();
};

// Visitor-attached images. Kept in lockstep with StoreFeedbackRequest on the
// server (image-only, ≤10MB, ≤3 extras) — the client guard is UX; the server
// guard is the real boundary.
const MAX_IMAGES = 3;
const MAX_IMAGE_BYTES = 10 * 1024 * 1024;
const ALLOWED_IMAGE_TYPES = ['image/png', 'image/jpeg', 'image/gif', 'image/webp'];

const escapeHtml = ( value ) => String( value ).replace(/[&<>"']/g, ( c ) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;',
}[c]));

const expandIcon = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`;

const removeImageIcon = `<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.5 3.5l-7 7M3.5 3.5l7 7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`;

// Preflight error state — themed featured icon → title → subhead → primary
// CTA → quiet Waylight attribution. One clear action; no orphaned X close.
const errorStateTemplate = () => `
    <div id="waylight-modal-error" hidden>
        <div class="waylight-error-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path d="M12 9v4m0 4h.01M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </div>
        <h2 class="waylight-error-title">Bug reporting is unavailable</h2>
        <p class="waylight-error-message">Please contact this site's team directly.</p>
        <button class="waylight-error-dismiss" type="button">Got it</button>
        <div class="waylight-error-attribution">
            <span>Powered by</span>
            <a href="https://getwaylight.com" target="_blank" rel="noopener noreferrer" aria-label="Waylight">${waylightWordmark}</a>
        </div>
    </div>
`;

const commentsTemplate = () => {
    if( ! state.get('show_additional_comments') ) {
        return '';
    }

    return `
        <button id="waylight-add-additional-comments" type="button">Add additional comments</button>

        <div class="waylight-input-container" id="waylight-long-description-container">
            <textarea id="waylight-description" placeholder="Add any extra detail that would help…"></textarea>
        </div>
    `;
};

const template = () => {
    return `
        <div id="waylight-modal-background">
            <div id="waylight-modal" role="dialog" aria-modal="true" aria-labelledby="waylight-guest-reporting-modal-title">

                ${errorStateTemplate()}

                <div id="waylight-modal-form">
                    <div class="waylight-modal-header">
                        <div class="waylight-brand-badge" aria-hidden="true">
                            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13 2 4.5 13.5H11L10 22 19.5 10.5H13L13 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>

                        <button id="waylight-close-reporting-modal" type="button" aria-label="Close">
                            <svg width="18" height="18" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13 1L1 13M1 1L13 13" stroke="currentColor" stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </button>
                    </div>

                    <div class="waylight-modal-body">
                        <h2 id="waylight-guest-reporting-modal-title">${state.get('modal_title')}</h2>
                        <h3 id="waylight-guest-reporting-modal-secondary-text">${state.get('secondary_text')}</h3>

                        <div id="waylight-identity">
                            <div id="waylight-identity-avatar"></div>
                            <div id="waylight-identity-meta">
                                <span id="waylight-identity-name"></span>
                                <span id="waylight-identity-email"></span>
                            </div>
                            <button id="waylight-identity-reset" type="button">Not you?</button>
                        </div>

                        <div id="waylight-identity-fields">
                            <div class="waylight-input-container first-container">
                                <label for="waylight-guest-name">Name</label>
                                <input type="text" placeholder="Your name" id="waylight-guest-name"/>
                                <span id="waylight-guest-name-validation" class="waylight-validation">Please enter your name.</span>
                            </div>

                            <div class="waylight-input-container">
                                <label for="waylight-guest-email">Email</label>
                                <input type="email" placeholder="you@example.com" id="waylight-guest-email"/>
                                <span id="waylight-guest-email-validation" class="waylight-validation">Please enter your email.</span>
                            </div>
                        </div>

                        <div class="waylight-input-container relative">
                            <label for="waylight-issue-title">${state.get('feedback_prompt')}</label>
                            <input type="text" placeholder="ex. This text is hard to read" id="waylight-issue-title" class="waylight-form-field"/>
                            <span id="waylight-issue-title-length">0/200</span>
                            <span id="waylight-issue-title-validation" class="waylight-validation">Please enter your feedback</span>
                            ${commentsTemplate()}
                        </div>

                        <div class="waylight-input-container" id="waylight-attachments-container">
                            <label>Screenshots &amp; images</label>
                            <div id="waylight-attachments-grid"></div>
                            <span class="waylight-attach-hint">
                                <span class="waylight-attach-hint-pointer">Drag &amp; drop, paste, or click + to add an image</span>
                                <span class="waylight-attach-hint-touch">Tap + to add an image</span>
                            </span>
                            <input type="file" id="waylight-image-input" accept="image/png,image/jpeg,image/gif,image/webp" multiple hidden/>
                            <span id="waylight-images-error" class="waylight-validation"></span>
                        </div>
                    </div>

                    <div class="waylight-modal-footer">
                        <button id="waylight-submit-feedback" class="waylight-form-field">Submit Feedback</button>

                        <div id="waylight-powered">
                            <span>Powered by</span>
                            <a href="https://getwaylight.com" target="_blank" rel="noopener noreferrer" aria-label="Waylight">${waylightWordmark}</a>
                        </div>
                    </div>
                </div>

                <div id="waylight-drop-overlay" aria-hidden="true">
                    <div class="waylight-drop-icon">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M7 10l5-5 5 5M12 5v12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </div>
                    <span class="waylight-drop-text">Drop images to attach</span>
                </div>
            </div>
        </div>

        <div id="waylight-lightbox" hidden>
            <button id="waylight-lightbox-close" type="button" aria-label="Close preview">
                <svg width="18" height="18" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13 1L1 13M1 1L13 13" stroke="currentColor" stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </button>
            <img id="waylight-lightbox-image" alt="Screenshot preview"/>
        </div>
    `;
}

export class ReportingModal extends HTMLElement {
    submittingFeedback = false;
    validForm = true;
    lightboxOpen = false;
    scrollLocked = false;

    constructor() {
        super();
        this.attachShadow({ mode: 'open' });
    }

    connectedCallback() {
        this.render();
        this.subscribeToState();
        this.subscribeToEvents();
        this.attachEventListeners();

        // Paste-to-attach (⌘V / Ctrl+V). One document-level listener, guarded
        // to only act while the form is open so the host page's own paste
        // behaviour is untouched the rest of the time.
        document.addEventListener('paste', (event) => this.handlePaste(event));
    }

    disconnectedCallback() {

    }

    attributeChangedCallback(name, oldValue, newValue) {
        if (oldValue !== newValue) {
            this.render();
        }
    }

    render() {
        // The theme attribute drives the token blocks in the stylesheet
        // (auto follows the visitor's OS). The owner accent is injected
        // inline so the Submit button + focus rings paint in their brand
        // color regardless of theme.
        this.setAttribute('data-theme', state.get('theme') || 'auto');

        const accent = state.get('button_color') || '#155EEF';
        this.style.setProperty('--waylight-accent', accent);
        this.style.setProperty('--waylight-accent-ring', hexToRgba(accent, 0.20));
        this.style.setProperty('--waylight-accent-contrast', pickContrast(accent));

        this.shadowRoot.innerHTML = `
            <style>${reportingModalStyles}</style>
            ${template()}
        `;
    }

    subscribeToState() {
        state.subscribe((key, value) => {
            // Owner-controlled appearance can change at runtime (SPA calling
            // setTheme / setShowAdditionalComments, or the settings preview).
            // Re-render + re-bind so the closed modal reflects the latest
            // configuration the next time it opens.
            if (['theme', 'button_color', 'show_additional_comments'].includes(key)) {
                this.render();
                this.attachEventListeners();
            }
        });
    }

    subscribeToEvents() {
        eventBus.on('reporting-modal-shown', (data) => {
            // Stop the host page from scrolling behind the modal.
            this.lockScroll();

            // Preflight runs upstream in designBug() now — by the time we
            // get here, the caller already knows whether reporting is
            // available. If they passed a preflightError, render the error
            // state; otherwise wire up the form as before.
            if (data && data.preflightError) {
                this.showErrorState(data.preflightError);
                this.bindKeyPress();
                this.animateIn();
                state.set('reporting_state', 'reporting-modal');
                return;
            }

            this.showFormState();
            this.captureScreenshot( data );
            this.applyIdentityState();
            this.bindKeyPress();
            this.animateIn();
            state.set('reporting_state', 'reporting-modal');
        });
    }

    // Freeze the host page behind the modal. Runs on arbitrary customer sites,
    // so we save + restore their existing inline styles rather than assume any,
    // and pad for the scrollbar's width so the page doesn't shift when the
    // scrollbar is removed (a no-op on macOS-style overlay scrollbars).
    lockScroll() {
        if (this.scrollLocked || typeof document === 'undefined') {
            return;
        }
        this.scrollLocked = true;

        const docEl = document.documentElement;
        const body = document.body;

        this.previousScrollStyles = {
            htmlOverflow: docEl.style.overflow,
            bodyOverflow: body.style.overflow,
            bodyPaddingRight: body.style.paddingRight,
        };

        const scrollbarWidth = window.innerWidth - docEl.clientWidth;
        if (scrollbarWidth > 0) {
            const currentPadding = parseFloat(window.getComputedStyle(body).paddingRight) || 0;
            body.style.paddingRight = (currentPadding + scrollbarWidth) + 'px';
        }

        docEl.style.overflow = 'hidden';
        body.style.overflow = 'hidden';
    }

    unlockScroll() {
        if (! this.scrollLocked || typeof document === 'undefined') {
            return;
        }
        this.scrollLocked = false;

        const styles = this.previousScrollStyles || {};
        document.documentElement.style.overflow = styles.htmlOverflow || '';
        document.body.style.overflow = styles.bodyOverflow || '';
        document.body.style.paddingRight = styles.bodyPaddingRight || '';
    }

    // Add the open class a frame after the host is displayed so the entrance
    // transition actually plays (you can't transition from display:none).
    animateIn() {
        const bg = this.shadowRoot.querySelector('#waylight-modal-background');
        if (!bg) {
            return;
        }
        requestAnimationFrame(() => requestAnimationFrame(() => bg.classList.add('waylight-open')));
    }

    showErrorState(code) {
        const errorPane = this.shadowRoot.querySelector('#waylight-modal-error');
        const formPane = this.shadowRoot.querySelector('#waylight-modal-form');
        if (! errorPane || ! formPane) {
            return;
        }

        // Surface-appropriate copy — never names the customer, never
        // says "billing" or "subscription" to anonymous visitors. The
        // visitor can't fix any of these; we just tell them where it
        // stops being their problem.
        const copyByCode = {
            project_not_found: "This bug reporter isn't connected anymore. Please contact this site's team directly.",
            project_key_missing: "This bug reporter isn't connected anymore. Please contact this site's team directly.",
            widget_not_enabled: "Bug reporting isn't enabled on this site right now.",
            billing_inactive: "Bug reporting is temporarily unavailable. Please contact this site's team directly.",
        };

        const message = copyByCode[code] || "Bug reporting isn't available right now. Please try again later.";

        this.shadowRoot.querySelector('.waylight-error-message').textContent = message;
        formPane.setAttribute('hidden', '');
        errorPane.removeAttribute('hidden');
    }

    showFormState() {
        const errorPane = this.shadowRoot.querySelector('#waylight-modal-error');
        const formPane = this.shadowRoot.querySelector('#waylight-modal-form');
        if (! errorPane || ! formPane) {
            return;
        }

        errorPane.setAttribute('hidden', '');
        formPane.removeAttribute('hidden');
    }

    attachEventListeners() {
        this.shadowRoot.querySelector('#waylight-submit-feedback')
            .addEventListener('click', (event) => {
                this.submitFeedback(event);
            });

        this.shadowRoot.querySelector('#waylight-modal-background')
            .addEventListener('click', (event) => {
                this.handleModalBackgroundClick(event);
            });

        this.shadowRoot.querySelector('#waylight-issue-title')
            .addEventListener('keyup', (event) => {
                this.listenIssueTitleChange(event);
            });

        this.shadowRoot.querySelector('#waylight-close-reporting-modal')
            .addEventListener('click', (event) => {
                this.handleCloseReportingModal(event);
            });

        this.shadowRoot.querySelector('#waylight-lightbox')
            .addEventListener('click', () => {
                this.closeLightbox();
            });

        this.shadowRoot.querySelector('#waylight-lightbox-close')
            .addEventListener('click', (event) => {
                event.stopPropagation();
                this.closeLightbox();
            });

        // Attachments: one hidden file input shared by the grid's "+" tile
        // (wired in renderAttachments), drag-drop, and paste.
        this.shadowRoot.querySelector('#waylight-image-input')
            .addEventListener('change', (event) => {
                this.handleImageSelect(event);
            });

        // Drag a file anywhere over the modal → frosted drop overlay.
        this.bindDragAndDrop();

        // "Not you?" forgets the remembered identity and re-shows the fields.
        this.shadowRoot.querySelector('#waylight-identity-reset')
            .addEventListener('click', () => {
                this.forgetIdentity();
            });

        // The "Add additional comments" affordance only exists when the
        // owner has enabled it — guard before binding.
        const addComments = this.shadowRoot.querySelector('#waylight-add-additional-comments');
        if (addComments) {
            addComments.addEventListener('click', (event) => {
                this.addAdditionalComments(event);
            });
        }

        const errorDismiss = this.shadowRoot.querySelector('.waylight-error-dismiss');
        if (errorDismiss) {
            errorDismiss.addEventListener('click', () => {
                this.closeReportingModal();
            });
        }
    }

    submitFeedback() {
        if( !state.get('capturing_screenshot') ) {
            this.submit();
        }else{
            console.log('Still capturing screenshot');
        }
    }

    handleModalBackgroundClick( event ) {
        if (event.target.closest('#waylight-modal')) {
            return;
        }

        bugData.resetBugData();
        this.resetForm();
        this.removeActiveBugMarker();
        this.removeTextBoxes();
        this.closeReportingModal();
    }

    listenIssueTitleChange( e ){
        let value = e.target.value;

        this.shadowRoot.querySelector('#waylight-issue-title-length').innerText = value.length +'/200';

        if( value.length >= 200 ){
            this.shadowRoot.querySelector('#waylight-issue-title-length').classList.add('over-limit');
        }else{
            this.shadowRoot.querySelector('#waylight-issue-title-length').classList.remove('over-limit');
        }

        if( value.length >= 160 ){
            this.shadowRoot.querySelector('#waylight-issue-title').classList.add('no-input-icon');
            this.shadowRoot.querySelector('#waylight-issue-title-length').style.display = 'inline-block';
            this.shadowRoot.getElementById('waylight-issue-title').style.paddingRight = '80px';
        }

        if( value.length < 160 ){
            this.shadowRoot.querySelector('#waylight-issue-title').classList.remove('no-input-icon');
            this.shadowRoot.querySelector('#waylight-issue-title-length').style.display = 'none';
            this.shadowRoot.querySelector('#waylight-issue-title').style.paddingRight = '14px';
        }
    }

    handleCloseReportingModal( event ) {
        bugData.resetBugData();
        this.resetForm();
        this.clearValidations();
        this.removeActiveBugMarker();
        this.removeTextBoxes();
        this.closeReportingModal();
    }

    addAdditionalComments( event ) {
        const link = this.shadowRoot.querySelector('#waylight-add-additional-comments');
        const container = this.shadowRoot.querySelector('#waylight-long-description-container');
        if (link) { link.style.display = 'none'; }
        if (container) { container.style.display = 'flex'; }
    }

    // Decide between the remembered-identity chip and the Name/Email fields.
    applyIdentityState() {
        const identity = this.shadowRoot.querySelector('#waylight-identity');
        const fields = this.shadowRoot.querySelector('#waylight-identity-fields');
        const previous = this.loadPreviousSelections();

        if (previous && previous.name) {
            // Keep the hidden inputs populated so submit/validation still read
            // from them — the chip is just a friendlier display layer.
            this.restoreName(previous.name);
            this.restoreEmail(previous.email || '');

            this.shadowRoot.querySelector('#waylight-identity-avatar').textContent = initialsFor(previous.name);
            this.shadowRoot.querySelector('#waylight-identity-name').textContent = previous.name;
            this.shadowRoot.querySelector('#waylight-identity-email').textContent = previous.email || '';

            identity.style.display = 'flex';
            fields.style.display = 'none';

            setTimeout(() => this.shadowRoot.querySelector('#waylight-issue-title').focus(), 100);
            return;
        }

        identity.style.display = 'none';
        fields.style.display = 'block';
        this.shadowRoot.querySelector('#waylight-guest-name').focus();
    }

    forgetIdentity() {
        localStorage.removeItem('waylight-previous-selections');
        bugData.setName('');
        bugData.setEmail('');

        this.shadowRoot.querySelector('#waylight-guest-name').value = '';
        this.shadowRoot.querySelector('#waylight-guest-email').value = '';
        this.shadowRoot.querySelector('#waylight-identity').style.display = 'none';
        this.shadowRoot.querySelector('#waylight-identity-fields').style.display = 'block';
        this.shadowRoot.querySelector('#waylight-guest-name').focus();
    }

    openLightbox( url ) {
        const src = url || bugData.getScreenshot();
        if (!src) {
            return;
        }

        const box = this.shadowRoot.querySelector('#waylight-lightbox');
        this.shadowRoot.querySelector('#waylight-lightbox-image').src = src;
        box.removeAttribute('hidden');
        requestAnimationFrame(() => box.classList.add('waylight-open'));
        this.lightboxOpen = true;
    }

    handleImageSelect( event ) {
        const input = event.target;
        const files = Array.from(input.files || []);
        // Reset so re-selecting the same file still fires a change event.
        input.value = '';
        this.addImages(files);
    }

    // Shared by the "+" tile, drag-drop, and paste. Validates client-side
    // (the server re-validates in StoreFeedbackRequest) and re-renders.
    addImages( files ) {
        let error = '';

        for (const file of Array.from(files)) {
            if (bugData.getImages().length >= MAX_IMAGES) {
                error = 'You can add up to ' + MAX_IMAGES + ' images.';
                break;
            }
            if (! ALLOWED_IMAGE_TYPES.includes(file.type)) {
                error = 'Only PNG, JPG, GIF, or WebP images are supported.';
                continue;
            }
            if (file.size > MAX_IMAGE_BYTES) {
                error = 'Each image must be under 10MB.';
                continue;
            }
            bugData.addImage(file);
            // Mark the newest tile so only it springs in on the next render.
            this.justAddedKey = 'image-' + (bugData.getImages().length - 1);
        }

        this.renderAttachments();
        this.showImagesError(error);
    }

    // Rebuild the attachment grid: screenshot (or a preparing shimmer) first,
    // then each image, then the dashed "+" tile until the cap is reached.
    renderAttachments() {
        const grid = this.shadowRoot.querySelector('#waylight-attachments-grid');
        if (!grid) {
            return;
        }

        const screenshot = bugData.getScreenshot();
        const images = bugData.getImages();
        const tiles = [];

        if (state.get('capturing_screenshot')) {
            tiles.push('<div class="waylight-attach-tile waylight-attach-preparing"><span class="waylight-prepare-thumb"></span></div>');
        } else if (screenshot) {
            tiles.push(this.tileHtml('screenshot', screenshot, 'Screenshot', ''));
        }

        images.forEach((image, i) => {
            tiles.push(this.tileHtml('image-' + i, image.previewUrl, image.file.name || 'Image', i));
        });

        if (images.length < MAX_IMAGES) {
            tiles.push(`
                <button type="button" id="waylight-add-image" class="waylight-attach-tile waylight-attach-add" aria-label="Add image">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </button>
            `);
        }

        grid.innerHTML = tiles.join('');
        this.justAddedKey = null;

        // The hint references the "+" tile, so drop it once the cap is hit.
        const hint = this.shadowRoot.querySelector('.waylight-attach-hint');
        if (hint) {
            hint.style.display = images.length >= MAX_IMAGES ? 'none' : 'block';
        }

        const addBtn = grid.querySelector('#waylight-add-image');
        if (addBtn) {
            addBtn.addEventListener('click', () => {
                this.shadowRoot.querySelector('#waylight-image-input').click();
            });
        }

        grid.querySelectorAll('.waylight-attach-thumb').forEach((tile) => {
            const key = tile.dataset.key;
            const index = tile.dataset.imageIndex;

            tile.querySelector('.waylight-attach-expand').addEventListener('click', (event) => {
                event.stopPropagation();
                const url = key === 'screenshot'
                    ? bugData.getScreenshot()
                    : (bugData.getImages()[Number(index)] || {}).previewUrl;
                this.openLightbox(url);
            });

            tile.querySelector('.waylight-attach-remove').addEventListener('click', (event) => {
                event.stopPropagation();
                if (key === 'screenshot') {
                    bugData.setScreenshot('');
                } else {
                    bugData.removeImage(Number(index));
                }
                this.showImagesError('');
                this.renderAttachments();
            });
        });
    }

    tileHtml( key, url, label, index ) {
        const pop = key === this.justAddedKey ? ' waylight-tile-pop' : '';
        return `
            <div class="waylight-attach-tile waylight-attach-thumb${pop}" data-key="${key}" data-image-index="${index}" style="background-image: url('${url}')">
                <button type="button" class="waylight-attach-expand" aria-label="Preview ${escapeHtml(label)}">${expandIcon}</button>
                <button type="button" class="waylight-attach-remove" aria-label="Remove ${escapeHtml(label)}">${removeImageIcon}</button>
            </div>
        `;
    }

    bindDragAndDrop() {
        // Bind to the full-viewport scrim, not just the card: while the modal
        // is open the whole screen becomes the drop zone, so a stray drop on
        // the backdrop can't fall through to the host page and navigate it
        // away. preventDefault on dragover/drop is what suppresses that.
        const target = this.shadowRoot.querySelector('#waylight-modal-background');
        if (!target) {
            return;
        }
        this.dragDepth = 0;

        target.addEventListener('dragenter', (event) => {
            if (! this.dragHasFiles(event)) { return; }
            event.preventDefault();
            this.dragDepth++;
            this.showDropOverlay(true);
        });

        target.addEventListener('dragover', (event) => {
            if (! this.dragHasFiles(event)) { return; }
            event.preventDefault();
        });

        target.addEventListener('dragleave', (event) => {
            if (! this.dragHasFiles(event)) { return; }
            this.dragDepth--;
            if (this.dragDepth <= 0) {
                this.dragDepth = 0;
                this.showDropOverlay(false);
            }
        });

        target.addEventListener('drop', (event) => {
            event.preventDefault();
            this.dragDepth = 0;
            this.showDropOverlay(false);
            if (event.dataTransfer) {
                this.addImages(event.dataTransfer.files);
            }
        });
    }

    dragHasFiles( event ) {
        const types = event.dataTransfer ? Array.from(event.dataTransfer.types || []) : [];
        return types.includes('Files');
    }

    showDropOverlay( show ) {
        const overlay = this.shadowRoot.querySelector('#waylight-drop-overlay');
        if (!overlay) {
            return;
        }
        // Never paint the overlay over the preflight-error state.
        const formPane = this.shadowRoot.querySelector('#waylight-modal-form');
        if (show && (!formPane || formPane.hasAttribute('hidden'))) {
            return;
        }
        overlay.classList.toggle('waylight-open', show);
    }

    resetDragState() {
        this.dragDepth = 0;
        this.showDropOverlay(false);
    }

    handlePaste( event ) {
        if (state.get('reporting_state') !== 'reporting-modal') {
            return;
        }
        const formPane = this.shadowRoot.querySelector('#waylight-modal-form');
        if (!formPane || formPane.hasAttribute('hidden')) {
            return;
        }

        const items = (event.clipboardData && event.clipboardData.items) || [];
        const files = [];
        for (const item of items) {
            if (item.kind === 'file' && item.type.indexOf('image/') === 0) {
                const file = item.getAsFile();
                if (file) {
                    files.push(file);
                }
            }
        }

        if (files.length) {
            event.preventDefault();
            this.addImages(files);
        }
    }

    showImagesError( message ) {
        const el = this.shadowRoot.querySelector('#waylight-images-error');
        if (message) {
            el.textContent = message;
            el.style.display = 'block';
        } else {
            el.textContent = '';
            el.style.display = 'none';
        }
    }

    closeLightbox() {
        const box = this.shadowRoot.querySelector('#waylight-lightbox');
        box.classList.remove('waylight-open');
        this.lightboxOpen = false;
        setTimeout(() => {
            box.setAttribute('hidden', '');
            this.shadowRoot.querySelector('#waylight-lightbox-image').src = '';
        }, 160);
    }

    resetForm() {
        this.shadowRoot.querySelector('#waylight-guest-name').value = '';
        this.shadowRoot.querySelector('#waylight-guest-email').value = '';
        this.shadowRoot.querySelector('#waylight-issue-title').value = '';
        this.shadowRoot.querySelector('#waylight-issue-title-length').innerText = '0/200';
        this.shadowRoot.querySelector('#waylight-issue-title').classList.remove('no-input-icon');

        // Identity back to the first-time baseline; applyIdentityState() picks
        // the chip again on the next open if we still remember the visitor.
        this.shadowRoot.querySelector('#waylight-identity').style.display = 'none';
        this.shadowRoot.querySelector('#waylight-identity-fields').style.display = 'block';

        // The comments affordance only exists when enabled by the owner.
        const description = this.shadowRoot.querySelector('#waylight-description');
        const addComments = this.shadowRoot.querySelector('#waylight-add-additional-comments');
        const longContainer = this.shadowRoot.querySelector('#waylight-long-description-container');
        if (description) { description.value = ''; }
        if (addComments) { addComments.style.display = 'flex'; }
        if (longContainer) { longContainer.style.display = 'none'; }

        // Attachments — bugData (screenshot + images) is cleared by
        // resetBugData(); re-render the (now empty) grid + clear error/drag state.
        this.renderAttachments();
        this.showImagesError('');
        this.resetDragState();
    }

    removeActiveBugMarker() {
        let activeBug = document.querySelectorAll('.active-waylight-bug-location');

        if( activeBug.length > 0 ) {
            for( let i = 0; i < activeBug.length; i++ ) {
                activeBug[i].remove();
            }
        }
    }

    removeTextBoxes() {
        let textBoxes = document.querySelectorAll('.waylight-text-input');

        if( textBoxes.length > 0 ) {
            for( let i = 0; i < textBoxes.length; i++ ) {
                textBoxes[i].remove();
            }
        }
    }

    bindKeyPress() {
        // hotkeys-js ignores INPUT/TEXTAREA/SELECT by default, but the whole
        // point of ⌘/Ctrl+Enter is to fire while the visitor is typing in a
        // field — so opt every field in. The bundled hotkeys instance is
        // scoped to this embed, so this never touches the host page.
        hotkeys.filter = () => true;

        // command+enter is macOS ⌘; ctrl+enter is Windows/Linux.
        hotkeys('ctrl+enter,command+enter', (event) => {
            event.preventDefault();
            this.submitFeedback(event);
        });
        hotkeys('escape', (event) => {
            // Escape closes the lightbox first if it's open, otherwise the modal.
            if (this.lightboxOpen) {
                this.closeLightbox();
                return;
            }
            bugData.resetBugData();
            this.resetForm();
            this.clearValidations();
            this.removeActiveBugMarker();
            this.removeTextBoxes();
            this.closeReportingModal();
        });
    }

    unbindKeyPress() {
        hotkeys.unbind('ctrl+enter,command+enter');
        hotkeys.unbind('escape');
    }

    captureScreenshot( data ) {
        const submit = this.shadowRoot.querySelector('#waylight-submit-feedback');

        // New flow: by the time the modal opens, an annotated screenshot is
        // already in bugData (the Designer captured + annotated + handed it
        // off via the designer:done event). Just render it as the first tile.
        const existing = bugData.getScreenshot();
        if (data?.hasAnnotatedScreenshot || existing) {
            state.set('capturing_screenshot', false);
            submit.style.opacity = '1.0';
            this.renderAttachments();
            this.removeTextBoxes();
            return;
        }

        // Fallback: opened without an annotated screenshot — capture one so the
        // user still gets a screenshot attached. The grid shows a shimmer tile
        // until it lands.
        state.set('capturing_screenshot', true);
        submit.style.opacity = '0.5';
        this.renderAttachments();

        captureHostPage()
            .then((dataUrl) => {
                bugData.setScreenshot(dataUrl);
                submit.style.opacity = '1.0';
                this.removeTextBoxes();
            })
            .catch((err) => console.error('[waylight] screenshot capture failed', err))
            .finally(() => {
                state.set('capturing_screenshot', false);
                this.renderAttachments();
            });
    }

    restoreName( name ) {
        bugData.setName( name );
        this.shadowRoot.querySelector('#waylight-guest-name').value = name;
    }

    restoreEmail( email ) {
        bugData.setEmail( email );
        this.shadowRoot.querySelector('#waylight-guest-email').value = email;
    }

    loadPreviousSelections() {
        let previousSelections = localStorage.getItem('waylight-previous-selections');

        if( !previousSelections ){
            return null;
        }

       previousSelections = JSON.parse(previousSelections);
       let currentTime = new Date();

       if( currentTime.getTime() > previousSelections.expires_at ){
            localStorage.removeItem('waylight-previous-selections');
            return null;
       }

       return previousSelections.value;
    }

    setSubmitting( isSubmitting ) {
        const submit = this.shadowRoot.querySelector('#waylight-submit-feedback');
        if( isSubmitting ){
            submit.innerHTML = '<span class="waylight-submit-spinner"></span>Submitting…';
            submit.style.opacity = '0.85';
            submit.style.pointerEvents = 'none';
        }else{
            submit.textContent = 'Submit Feedback';
            submit.style.opacity = '1';
            submit.style.pointerEvents = '';
        }
    }

    async submit(){
        this.setBugData();

        if( this.validate()
            && !this.submittingFeedback ){
                this.submittingFeedback = true;
                this.setSubmitting(true);

                let formData = await bugData.convertToFormData();

                let endpoint = state.get('endpoint');

                fetch( endpoint+'/feedback', {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json'
                    },
                    body: formData
                } ).then( async response => {
                    this.submittingFeedback = false;
                    this.setSubmitting(false);

                    if( response.ok ){
                        this.saveSelections();
                        bugData.resetBugData();
                        this.resetForm();
                        this.removeActiveBugMarker();
                        this.removeTextBoxes();
                        this.closeReportingModal();

                        eventBus.emit('notify', { type: 'success' });
                        return;
                    }

                    // Server refused. Surface a respectful message — and
                    // for any of the known codes, NEVER name the customer
                    // or expose owner contact info. This widget runs on
                    // the customer's public page, so anything we show is
                    // visible to anonymous visitors.
                    let message = "We couldn't submit your feedback. Please try again.";
                    try{
                        const contentType = response.headers.get( 'content-type' ) || '';
                        if( contentType.includes( 'application/json' ) ){
                            const body = await response.json();
                            if( body && body.code === 'billing_inactive' ){
                                message = "Bug reporting is temporarily unavailable. Please contact this site's team directly.";
                            }else if( body && (body.code === 'project_not_found' || body.code === 'project_key_missing') ){
                                // A snippet pointing at a project that no
                                // longer exists (or one missing the project
                                // key entirely). Most often happens when a
                                // team is deleted but the snippet is left
                                // on the page. Visitor can't fix this; we
                                // tell them where it stops being their
                                // problem.
                                message = "This bug reporter isn't connected anymore. Please contact this site's team directly.";
                            }else if( body && body.code === 'widget_not_enabled' ){
                                message = "Bug reporting isn't enabled on this site right now.";
                            }
                        }
                    }catch{
                        // Stay on the generic fallback. The visitor doesn't
                        // need to see parse / network plumbing.
                    }

                    eventBus.emit('notify', { type: 'error', message });

                } ).catch( () => {
                    this.submittingFeedback = false;
                    this.setSubmitting(false);
                    eventBus.emit('notify', { type: 'error', message: "We couldn't submit your feedback. Please try again." });
                } );
        }
    }

    validate() {
        this.validForm = true;

        this.checkTitle();
        this.checkName();
        this.checkEmail();

        return this.validForm;
    }

    checkTitle(){
        let title = this.shadowRoot.querySelector('#waylight-issue-title').value;

        if( title == '' ){
            this.validForm = false;
            this.shadowRoot.querySelector('#waylight-issue-title-validation').style.display = 'block';
            this.shadowRoot.querySelector('#waylight-issue-title').classList.add('invalid');
        }else if( title.length > 200 ){
            this.validForm = false;
            this.shadowRoot.querySelector('#waylight-issue-title-validation').style.display = 'block';
            this.shadowRoot.querySelector('#waylight-issue-title').classList.add('invalid');
        }else{
            this.shadowRoot.querySelector('#waylight-issue-title-validation').style.display = 'none';
            this.shadowRoot.querySelector('#waylight-issue-title').classList.remove('invalid');
        }
    }

    checkName(){
        // When the identity chip is showing, Name lives in a hidden but
        // populated input — validation still reads from it correctly.
        let name = this.shadowRoot.querySelector('#waylight-guest-name').value;

        if( name == '' ){
            this.validForm = false;
            this.shadowRoot.querySelector('#waylight-guest-name-validation').style.display = 'block';
            this.shadowRoot.querySelector('#waylight-guest-name').classList.add('invalid');
        }else{
            this.shadowRoot.querySelector('#waylight-guest-name-validation').style.display = 'none';
            this.shadowRoot.querySelector('#waylight-guest-name').classList.remove('invalid');
        }
    }

    checkEmail(){
        let email = this.shadowRoot.querySelector('#waylight-guest-email').value;

        if( email == '' ){
            this.validForm = false;
            this.shadowRoot.querySelector('#waylight-guest-email-validation').style.display = 'block';
            this.shadowRoot.querySelector('#waylight-guest-email').classList.add('invalid');
        }else if( !email.match(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/) ){
            this.validForm = false;
            this.shadowRoot.querySelector('#waylight-guest-email-validation').style.display = 'block';
            this.shadowRoot.querySelector('#waylight-guest-email').classList.add('invalid');
        }else{
            this.shadowRoot.querySelector('#waylight-guest-email-validation').style.display = 'none';
            this.shadowRoot.querySelector('#waylight-guest-email').classList.remove('invalid');
        }
    }

    clearValidations(){
        this.shadowRoot.querySelector('#waylight-issue-title-validation').style.display = 'none';
        this.shadowRoot.querySelector('#waylight-issue-title').classList.remove('invalid');
        this.shadowRoot.querySelector('#waylight-guest-name-validation').style.display = 'none';
        this.shadowRoot.querySelector('#waylight-guest-name').classList.remove('invalid');
        this.shadowRoot.querySelector('#waylight-guest-email-validation').style.display = 'none';
        this.shadowRoot.querySelector('#waylight-guest-email').classList.remove('invalid');
    }

    setBugData(){
        const description = this.shadowRoot.querySelector('#waylight-description');

        bugData.setName( this.shadowRoot.querySelector('#waylight-guest-name').value );
        bugData.setEmail( this.shadowRoot.querySelector('#waylight-guest-email').value );
        bugData.setTitle( this.shadowRoot.querySelector('#waylight-issue-title').value );
        bugData.setDescription( description ? description.value : '' );
        bugData.setUrl( window.location.href );
        bugData.setBrowserInfo();
        // Merge after setBrowserInfo() — it rebuilds this.meta from scratch,
        // so custom metadata must be applied last to survive the rebuild.
        bugData.setCustomMetadata( state.get('metadata') );
        bugData.setKey( state.get('key') );
    }

    saveSelections(){
        let currentTime = new Date();

        let selections = {
            value: {
                name: bugData.getName(),
                email: bugData.getEmail(),
            },
            expires_at: currentTime.getTime() + ( 3600 * 1000 )
        }

        localStorage.setItem('waylight-previous-selections', JSON.stringify( selections ));
    }

    closeReportingModal(){
        if (this.lightboxOpen) {
            this.closeLightbox();
        }

        this.resetDragState();
        this.unlockScroll();
        this.unbindKeyPress();

        // Play the exit transition, then hand back to the controller to hide
        // the host. The delay matches the scrim fade-out duration.
        const bg = this.shadowRoot.querySelector('#waylight-modal-background');
        if (bg) {
            bg.classList.remove('waylight-open');
        }
        setTimeout(() => eventBus.emit('close-reporting-modal'), 200);
    }
}
